module.exports = __webpack_public_path__ + "static/media/feat-tcr-img4.2798d1e0.jpg";